var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-navigation-drawer",
    {
      attrs: { temporary: "", right: _vm.right, fixed: "", app: "" },
      model: {
        value: _vm.$store.state.layout.rightDrawer,
        callback: function($$v) {
          _vm.$set(_vm.$store.state.layout, "rightDrawer", $$v)
        },
        expression: "$store.state.layout.rightDrawer"
      }
    },
    [
      _c(
        "v-list",
        [
          _c(
            "v-list-tile",
            [
              _c(
                "v-list-tile-action",
                [_c("v-icon", [_vm._v("notifications")])],
                1
              ),
              _vm._v(" "),
              _c("v-list-tile-title", [_vm._v("Notificaciones")])
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0a923ac2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0a923ac2","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/common/layout/AppNotification.vue
// module id = null
// module chunks = 